import { Grid, Stack } from "@mui/material";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import SmartSelector from "@/Layouts/components/InputComponents/SmartSelector";
import { errorLogger } from "@/Common/helpers/logger";
import { ISystemSettings } from "@/Settings/types/Common/model";
import Title from "../../../common/Title";
import { updateSystemSettings } from "@/Settings/api/SystemSettings/mutations";

const twoHundredFifty = 250;

const intervals = Array.from({ length: Math.floor((10000 - 0) / twoHundredFifty) + 1 }, (_, i) => ({
	label: `$${0 + i * twoHundredFifty}`,
	value: 0 + i * twoHundredFifty,
}));

type TMinimumBalanceProps = {
	locationId: string;
	citMinimumBalance?: number;
};

const MinimumBalance = (props: TMinimumBalanceProps) => {
	const { locationId, citMinimumBalance } = props;
	const queryClient = useQueryClient();

	const { mutate, isPending } = useMutation({
		mutationKey: ["citMinimumBalance", locationId],
		mutationFn: (input: { citMinimumBalance: number }) => updateSystemSettings(locationId, input, "MINIMUM_BALANCE"),
		onSuccess: (result: ISystemSettings) => {
			queryClient.setQueryData(["systemSettings", locationId], (cachedData: ISystemSettings) => {
				return {
					...cachedData,
					citMinimumBalance: result.citMinimumBalance,
				};
			});
		},
		onError: (error) => {
			errorLogger(error);
		},
	});

	const handleChange = (value: { label: string; value: number }) => {
		const input = {
			citMinimumBalance: Number(value.value),
		};
		mutate(input);
	};

	return (
		<Grid container direction={"column"}>
			<Grid item>
				<Stack>
					<Title title="Minimum Balance" className="!mb-[24px]" />
					<SmartSelector
						selectBy={"label"}
						showBy={"label"}
						options={intervals}
						selected={citMinimumBalance ? { label: `$${citMinimumBalance}` } : null}
						inputProps={{
							placeholder: "Minimum Balance",
						}}
						disabled={isPending}
						loading={isPending}
						sx={{ width: "150px" }}
						onChangeAction={(value) => handleChange(value as { label: string; value: number })}
					/>
				</Stack>
			</Grid>
		</Grid>
	);
};

export default MinimumBalance;
